import brand from '@helpers/brand';
import { fonts } from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Device, from, until } from '@helpers/media';
import SiteWide from '@stories/Components/Containers/SiteWide/SiteWide.styles';
import IntroductionContentStyles from '@stories/Components/Content/IntroductionContent/IntroductionContent.styles';
import HeadingStyles from '@stories/Components/Global/Typography/Heading.styles';
import ParagraphStyles from '@stories/Components/Global/Typography/Paragraph.styles';
import styled, { css } from 'styled-components';
const Wrapper = styled.div `
  padding: 40px 0;

  @media ${until(Device.TabletLarge)} {
    padding: 20px 0 0;

    ${ParagraphStyles.Paragraph} {
      font-size: 16px;
      line-height: 1.5;
    }
  }

  ${IntroductionContentStyles.Title} {
    ${fonts.DaxPro['Bold']};
  }

  ${HeadingStyles.Heading} {
    color: ${brand.black};
  }
`;
const Inner = styled.div `
  @media ${from(Device.TabletLarge)} {
    padding: 0 40px;
  }
`;
const Container = styled.div `
  padding: 0px 13px;

  @media ${from(Device.MobileLarge)} {
    padding: 0px 40px;
  }

  @media ${from(Device.Tablet)} {
    padding: 0px 60px;
  }

  @media ${from(Device.TabletLarge)} {
    padding: 0px 80px;
  }

  @media ${from(Device.DesktopSmall)} {
    padding: 0px 100px;
  }

  @media ${from(Device.Desktop)} {
    padding: 0px 128px;
  }
`;
const Title = styled.h1 `
  ${SiteWide.containerStyles};
  padding: 0;
  font-size: 35px;
  ${fonts.DaxPro['Medium']};
  color: ${brand.grey.grey20};

  @media ${until(Device.TabletLarge)} {
    margin-bottom: 20px;
  }
`;
const ControlsWrapper = styled.div `
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-top: 30px;
`;
const Pagination = styled.div `
  display: flex;
  flex-wrap: wrap;
  width: 96px;

  small {
    display: block;
    width: 100%;
    font-size: 18px;
    ${fonts.DaxPro['Regular']};
    margin-bottom: 10px;
  }
`;
const ArrowButton = styled.button.attrs({ type: 'button' }) `
  ${ButtonReset};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  background-color: ${brand.primary.base};
  color: ${brand.white};

  ${({ direction }) => {
    switch (direction) {
        case 'left':
            return css `
          margin-right: 6px;

          svg {
            transform: rotate(180deg);
          }
        `;
        case 'right':
            return css ``;
        default:
            break;
    }
}}

  ${({ disabled }) => disabled &&
    css `
      opacity: 0.5;

      &:hover {
        background-color: ${brand.primary.base};
      }
    `}

    svg {
    width: 13px;
  }
`;
const ModalInner = styled.div `
  text-align: center;
  margin: 40px 0;

  ${ParagraphStyles.Paragraph} {
    margin-bottom: 50px;
  }
`;
const Svg = styled.div `
  margin-bottom: 30px;

  svg {
    width: 50px;
    height: 50px;
    color: ${brand.primary.base};

    @media ${from(Device.TabletLarge)} {
      width: 70px;
      height: 70px;
    }
  }
`;
export const ViewHiresStyles = {
    Wrapper,
    Inner,
    Container,
    Title,
    ControlsWrapper,
    Pagination,
    ArrowButton,
    ModalInner,
    Svg,
};
